define('plugin/invoice/controller/InvoiceRecurringProfileController',['require','lib/controller/BaseController','lib/pager/Pager','plugin/invoice/collection/InvoiceCollection','plugin/invoice/collection/InvoiceRecurringProfileCollection','plugin/invoice/model/InvoiceRecurringProfileModel','plugin/invoice/view/InvoiceRecurringProfileListView','plugin/invoice/view/InvoiceRecurringProfileLayout'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var Pager = require('lib/pager/Pager');

    var InvoiceCollection = require('plugin/invoice/collection/InvoiceCollection');
    var InvoiceRecurringProfileCollection = require('plugin/invoice/collection/InvoiceRecurringProfileCollection');

    var InvoiceRecurringProfileModel = require('plugin/invoice/model/InvoiceRecurringProfileModel');

    var InvoiceRecurringProfileListView = require('plugin/invoice/view/InvoiceRecurringProfileListView');
    var InvoiceRecurringProfileLayout = require('plugin/invoice/view/InvoiceRecurringProfileLayout');

    /**
     * Invoice recurring profile controller
     *
     * @class InvoiceRecurringProfileController
     */
    return BaseController.extend({

        profileModel: null,

        view: function (id, page) {
            if (!this.profileModel || this.profileModel.get('id') !== id) {
                this.profileModel = new InvoiceRecurringProfileModel({
                    id: id
                });
                this.profileModel.fetch();
            }

            var pager = new Pager();
            pager.setFilter('recurring_profile_id', id);

            var collection = new InvoiceCollection({
                pager: pager
            });

            var view = new InvoiceRecurringProfileLayout({
                model: this.profileModel,
                collection: collection,
                pagerUrl: 'invoice-recurring-profile/view/' + id + '/page/:page'
            });

            this.listenTo(view, 'profile:cancel', this._cancelProfile);

            this.getMainLayout().getContentRegion().show(view);

            view.displayProfileDetails();

            pager.setPage(page);

            this.listenTo(collection, 'sync', function () {
                if (!view.isDestroyed) {
                    view.displayInvoiceCollection();
                }
            });
        },

        _cancelProfile: function (model) {
            model.destroy({success: _.bind(function () {
                this.profileModel.fetch();
            }, this)});
        },

        list: function (page) {
            var collection = new InvoiceRecurringProfileCollection();
            collection.getPager().setPage(page);

            this.listenTo(collection, 'sync', _.bind(function () {
                var listView = new InvoiceRecurringProfileListView({
                    collection: collection,
                    label: 'invoices_list',
                    wrap: true,
                    url: 'invoice-recurring-profile/list/page/:page'
                });

                this.getMainLayout().getContentRegion().show(listView);
            }, this));
        }

    });

});
